export default __webpack_public_path__ + "static/media/explore-iv-banner-3@2x.070571bd.png";